import { InputMaskProcessingBase } from '../input-mask-processing.base';

export class EinMaskProcessing extends InputMaskProcessingBase {
  protected allowedChars = '0123456789';
  protected fixedPosGroupingChars = [null, null, '-'];
  protected maxLength = 10;
}
